import { useMutation } from "@tanstack/react-query";
import { resendVerification } from "../api/resendVerification";

export const useResendVerification = () => {
  return useMutation({
    mutationFn: ({ email }) => resendVerification({ email }),
  });
};

